import axios from 'axios';
import { syncAmenitiesApi } from '../api';
const amenitiesActions = {
    syncAmenities: async ({ projectId, data: payload }, { setState }) => {
        try {
            const { data: res } = await syncAmenitiesApi(projectId, { ids: payload });
            setState((state) => {
                if (state.project.data?.amenities) {
                    state.project.data.amenities = res;
                }
            });
            return res;
        }
        catch (err) {
            if (axios.isAxiosError(err))
                throw err.response?.data;
            throw err;
        }
    },
};
export default amenitiesActions;
